import styles from './InvestigationSummary.module.scss';
import { useGetInvestigationQuery } from '@customer/store/apis/investigationsApi';
import { useParams } from 'react-router-dom';
import { useAppSelector } from '@customer/store/hooks';
import { skipToken } from '@reduxjs/toolkit/query';
import InteractionSummaryVI from '@customer/components/data-display/interaction-summary-vi/InteractionSummaryVI';
import InteractionSummaryGI from '@customer/components/data-display/interaction-summary-gi/InteractionSummaryGI';
import {
  isAssetGIModel,
  isAssetVIModel,
  isLoggedInvestigation,
} from '@customer/shared/utils/investigationHelper';
import { ReactElement } from 'react';

export const InvestigationSummary = (): ReactElement | null => {
  const { investigationId } = useParams();

  const siteId = useAppSelector(state => state.auth.siteId);
  const view = useAppSelector(state => state.investigationGui.view);

  const isSkipQuery = typeof investigationId === 'undefined' || typeof siteId === 'undefined';

  const { currentData: investigation } = useGetInvestigationQuery(
    isSkipQuery ? skipToken : { siteId, investigationId },
    { refetchOnMountOrArgChange: 60 },
  );

  if (investigation === undefined || !isLoggedInvestigation(investigation)) {
    return null;
  }

  return (
    // Use 'view' as a key to force the child table to re-calculate the dimensions when the layout changes.
    <div className={styles.container} key={view}>
      {isAssetVIModel(investigation) && (
        <InteractionSummaryVI interaction={investigation} verticalPadding />
      )}
      {isAssetGIModel(investigation) && <InteractionSummaryGI interaction={investigation} />}
    </div>
  );
};

export default InvestigationSummary;
